export default "__VITE_ASSET__DooeDVIU__"